// src/context/OidcAuthProvider.js
import React, { createContext } from 'react';
import { AuthProvider as OidcAuthProvider, useAuth as useOidc } from 'react-oidc-context';
import { oidcConfig, oidcConfigUAT } from '../config/oidcConfig';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => (
  <OidcAuthProvider
    {...oidcConfig} //DEV
    // {...oidcConfigUAT} //UAT
    onSigninCallback={() => {
      // console.log('User signed in');
    }}
    onError={(error) => {
      console.error('OIDC Authentication Error:', error);
      alert('An authentication error occurred. Please try again or contact support if the issue persists.');
    }}
  >
    {children}
  </OidcAuthProvider>
);

export const useAuth = () => useOidc();
